var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0399 12.9601C11.4067 14.327 13.6228 14.327 14.9896 12.9601L18.5252 9.42459C19.892 8.05776 19.892 5.84168 18.5252 4.47484C17.1583 3.10801 14.9423 3.10801 13.5754 4.47484L11.8077 6.24261",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8683 10.1316C11.5015 8.76476 9.28541 8.76476 7.91857 10.1316L4.38304 13.6671C3.0162 15.034 3.0162 17.25 4.38304 18.6169C5.74987 19.9837 7.96595 19.9837 9.33278 18.6169L11.1006 16.8491",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-2.c76fc79e51476f7a92f60898dcdfc1ba.svg";